module.exports = "/img/volkswagen.ec268ae0.png";